const values = {
    "ADD_OR_REMOVE_BALANCE": "Adicionar/Restar saldo",
    "TRANSACTIONS": "Transacciones",
    "NO_TRANSACTIONS_TITLE": "No hay transacciones!!!",
    "NO_TRANSACTIONS_SUBTITLE": "Verifica si estas aplicando algún filtro",
    "BALANCE_BEFORE": "Saldo anterior",
}

export default values;